var _excluded = ["lang", "onChange"],
  _excluded2 = ["attributes", "children", "nodeProps", "styles", "element", "classNames", "prefixClassNames"],
  _excluded3 = ["attributes", "children", "nodeProps", "styles", "element", "classNames", "prefixClassNames"],
  _excluded4 = ["options"];
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createStyles } from '@udecode/plate-styled-components';
import _styled, { css } from 'styled-components';
import React from 'react';
import { getCodeBlockPluginOptions, CODE_BLOCK_LANGUAGES_POPULAR, CODE_BLOCK_LANGUAGES, getCodeBlockType, insertEmptyCodeBlock } from '@udecode/plate-code-block';
import { setNodes, getPreventDefaultHandler } from '@udecode/plate-common';
import { useEditorRef, useStoreEditorState, useEventEditorId } from '@udecode/plate-core';
import { ReactEditor } from 'slate-react';
import { ToolbarElement } from '@udecode/plate-toolbar';
var getCodeBlockElementStyles = function getCodeBlockElementStyles(props) {
  return createStyles(_objectSpread({
    prefixClassNames: 'CodeBlockElement'
  }, props), {
    root: [{
      "whiteSpace": "pre-wrap",
      "paddingTop": "0.75rem",
      "paddingBottom": "0.75rem",
      "paddingLeft": "1rem",
      "paddingRight": "1rem"
    }, css(["font-size:16px;font-family:SFMono-Regular,Consolas,Monaco,'Liberation Mono',Menlo,Courier,monospace;tab-size:2;line-height:normal;border-radius:3px;background-color:rgb(247,246,243);"])]
  });
};
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var CodeBlockSelectElement = function CodeBlockSelectElement(_ref) {
  var lang = _ref.lang,
    _onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = React.useState(lang),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  var editor = useEditorRef();
  var code_block = getCodeBlockPluginOptions(editor);
  return /*#__PURE__*/React.createElement("select", _extends({
    value: value,
    style: {
      "float": 'right'
    },
    onClick: function onClick(e) {
      e.stopPropagation();
    },
    onChange: function onChange(e) {
      _onChange(e.target.value);
      setValue(e.target.value);
    },
    contentEditable: false
  }, props), /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Plain text"), (code_block === null || code_block === void 0 ? void 0 : code_block.syntaxPopularFirst) && Object.entries(CODE_BLOCK_LANGUAGES_POPULAR).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      val = _ref3[1];
    return /*#__PURE__*/React.createElement("option", {
      key: key,
      value: key
    }, val);
  }), Object.entries(CODE_BLOCK_LANGUAGES).map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      key = _ref5[0],
      val = _ref5[1];
    return /*#__PURE__*/React.createElement("option", {
      key: key,
      value: key
    }, val);
  }));
};
var CodeBlockElement = function CodeBlockElement(props) {
  var attributes = props.attributes,
    children = props.children,
    nodeProps = props.nodeProps,
    styles = props.styles,
    element = props.element,
    classNames = props.classNames,
    prefixClassNames = props.prefixClassNames,
    rootProps = _objectWithoutProperties(props, _excluded2);
  var lang = element.lang;
  var editor = useEditorRef();
  var _getCodeBlockElementS = getCodeBlockElementStyles(props),
    root = _getCodeBlockElementS.root;
  var code_block = getCodeBlockPluginOptions(editor);
  var codeClassName = lang ? "".concat(lang, " language-").concat(lang) : '';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_StyledPre, _extends({}, attributes, {
    className: root.className
  }, rootProps, nodeProps, {
    $_css: root.css
  }), (code_block === null || code_block === void 0 ? void 0 : code_block.syntax) && /*#__PURE__*/React.createElement(CodeBlockSelectElement, {
    "data-testid": "CodeBlockSelectElement",
    lang: lang,
    onChange: function onChange(val) {
      var path = ReactEditor.findPath(editor, element);
      setNodes(editor, {
        lang: val
      }, {
        at: path
      });
    }
  }), /*#__PURE__*/React.createElement("code", {
    className: codeClassName
  }, children)));
};
var _StyledPre = _styled("pre").withConfig({
  displayName: "CodeBlockElement___StyledPre",
  componentId: "sc-edret1-0"
})(["", ""], function (p) {
  return p.$_css;
});
var getCodeLineElementStyles = function getCodeLineElementStyles(props) {
  return createStyles(_objectSpread({
    prefixClassNames: 'CodeLineElement'
  }, props), {
    root: [{}]
  });
};
var CodeLineElement = function CodeLineElement(props) {
  var attributes = props.attributes,
    children = props.children,
    nodeProps = props.nodeProps,
    styles = props.styles,
    element = props.element,
    classNames = props.classNames,
    prefixClassNames = props.prefixClassNames,
    rootProps = _objectWithoutProperties(props, _excluded3);
  var _getCodeLineElementSt = getCodeLineElementStyles(props),
    root = _getCodeLineElementSt.root;
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({}, attributes, {
    className: root.className
  }, rootProps, nodeProps, {
    $_css: root.css
  }), children);
};
var _StyledDiv = _styled("div").withConfig({
  displayName: "CodeLineElement___StyledDiv",
  componentId: "sc-11fh9za-0"
})(["", ""], function (p) {
  return p.$_css;
});
var ToolbarCodeBlock = function ToolbarCodeBlock(_ref6) {
  var options = _ref6.options,
    props = _objectWithoutProperties(_ref6, _excluded4);
  var editor = useStoreEditorState(useEventEditorId('focus'));
  if (!editor) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ToolbarElement, _extends({
    type: getCodeBlockType(editor),
    onMouseDown: getPreventDefaultHandler(insertEmptyCodeBlock, editor, _objectSpread({
      insertNodesOptions: {
        select: true
      }
    }, options))
  }, props));
};
export { CodeBlockElement, CodeBlockSelectElement, CodeLineElement, ToolbarCodeBlock, getCodeBlockElementStyles, getCodeLineElementStyles };